// import { useState } from "react";
// import Card from "../home/card/card";
// import Pagination from "./pagination";
// import CardSkeleton from "../loader/skeleton/cardSkeleton";

// const MachineList = ({ isLoading, machineData }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const totalPages = 68;

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     // Add additional logic for fetching data if needed
//   };
//   return (
//     <>
//       <div className="grid grid-cols-3 gap-6 max-[1196px]:grid-cols-2 max-[842px]:grid-cols-1">
//         {/* {isLoading
//           ? [1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => {
//               return <CardSkeleton />;
//             })
//           : machineData.map((item) => {
//               return <Card listCard={true} data={item} />;
//             })} */}

//         <Card listCard={true} />
//         <Card listCard={true} />
//         <Card listCard={true} />
//         <Card listCard={true} />
//         <Card listCard={true} />
//         <Card listCard={true} />
//         <Card listCard={true} />
//         <Card listCard={true} />
//         <Card listCard={true} />
//       </div>

//       <div className="p-4 mt-[30px]">
//         <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
//       </div>
//     </>
//   );
// };
// export default MachineList;

// Back up Code
import { useState } from "react";
import Card from "../home/card/card";
import Pagination from "./pagination";
import CardSkeleton from "../loader/skeleton/cardSkeleton";
import NoMachineAvailable from "../home/noMachineAvailable";

const MachineList = ({ isLoading, machineData, totalRecords, showRecord, currentPage, setCurrentPage, isSearch }) => {
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <>
      <div className="grid grid-cols-3 gap-6 max-[1196px]:grid-cols-2 max-[842px]:grid-cols-1">
        {isLoading ? (
          [1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => {
            return <CardSkeleton />;
          })
        ) : machineData?.length <= 0 ? (
          <div className="h-[500px] flex items-center justify-center max-[1196px]:col-span-2 max-[842px]:col-span-1 col-span-3">
            <NoMachineAvailable />
          </div>
        ) : (
          machineData.map((item) => {
            return <Card listCard={true} data={item} isSearch={isSearch} />;
          })
        )}
      </div>
      {totalRecords > 0 ? (
        <div className="p-4 mt-[30px]">
          <Pagination
            totalPages={Math.ceil(totalRecords / showRecord)}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      ) : null}
    </>
  );
};
export default MachineList;
